module.exports = __webpack_public_path__ + "static/img/power-num.a761106b.png";